import { Controller } from 'stimulus';
import { Turbo } from '@hotwired/turbo-rails';
import DfApi from '@/js/modules/df_api';

export default class extends Controller {
  #api = new DfApi();

  async select(event) {
    const { projectId, contractId } = this.#getResourceIds(event);
    const clientIds = event.detail.clients
      ? event.detail.clients.map((c) => c.id)
      : event.detail.values;
    const response = await this.#api.buildClientSignatures(projectId, contractId, clientIds);
    const html = await response.text();

    Turbo.renderStreamMessage(html);
  }

  #getResourceIds(event) {
    const form = event.target.closest('form');
    const regex = /\/projects\/(\d+)\/contracts\/(\d+)/;
    const match = form.action.match(regex);

    return { projectId: match[1], contractId: match[2] };
  }
}
